import { render, staticRenderFns } from "./TableauResultatsChallenge.vue?vue&type=template&id=58c86413"
import script from "./TableauResultatsChallenge.vue?vue&type=script&lang=js"
export * from "./TableauResultatsChallenge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports